export default __webpack_public_path__ + "static/media/MiturLogo.55c4f8fa.png";